module.exports = __webpack_public_path__ + "static/media/instagram-logo.21424000.svg";